import styled, { css } from "styled-components";
import { MotionState } from "./types";
export const Positioner = styled.div `
  ${(props) => css `
    position: absolute;
    left: 0;
    top: 0;
    transform: translate3d(0, 0, 0);
    transition: ${props.isSafeToTransition ? "transform 64ms linear" : "none"};
    pointer-events: ${props.overlayPointerEvents
    ? props.overlayPointerEvents
    : props.shouldFollowCursor
        ? "none"
        : "all"};
    z-index: ${props.zIndex};
    /* Prevents issues like DES-1894 */
    [data-motion-state="${MotionState.Closing}"] {
      pointer-events: none;
    }
    ${props.shouldMatchWidth &&
    `
      min-width: ${props.minWidth}px;`}
  `}
`;
